// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import type { TGlobalState, TUser, TBaseProps } from '../../../types';
import { ActivateTemplate } from '../../templates';
import { requestActivateUserAction, requestUserByCodeAction } from '../../../store/actions';

type TProps = TBaseProps & {
  user: TUser,
};

class Activate extends React.Component<TProps, {}> {
  constructor(props) {
    super(props);
    props.requestUserByCodeAction(props.code);
  }

  render() {
    return <ActivateTemplate {...this.props} />;
  }
}

const mapStateToProps = (state: TGlobalState, ownProps: TProps) => ({
  user: state.user.profile,
  validation: state.user.validation,
  code: ownProps.match.params.activation_code,
});
export const ActivatePage = connect(mapStateToProps, {
  requestUserByCodeAction,
  requestActivateUserAction,
})(Activate);
